import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenPatientServiceDetailComponent } from './gen-patient-service-detail.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [GenPatientServiceDetailComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild()
  ]
})
export class GenPatientServiceDetailModule { }
